export default __webpack_public_path__ + "locales/az/ArchiveDialog.json?hash=e5fa39e7211d3d7c5faae661393c537b";